const getDefaultState = () => {
    return {
        storeAgency: {
            id: null,
            name: null,
            exclusiveRates: null,
            exclusiveDiscounts: null
        },
        storeHotel: {
            id: 0,
            name: null
        },
        storeHasModified: {
            agency: false,
            rates: false,
            discounts: false,
            modalState: 0
        }
    }
}

export default{
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        fillAgencyData(state, data) {
            state.storeAgency.id = data.id;
            state.storeAgency.name = data.name;
            state.storeAgency.exclusiveRates = data.exclusiveRates;
            state.storeAgency.exclusiveDiscounts = data.exclusiveDiscounts;
        },
        fillHotelData(state, data) {
            state.storeHotel.id = data.id;
            state.storeHotel.name = data.name;
        },
        fillHasModified(state, data) {
            switch (data.data) {
                case 'agency':
                    state.storeHasModified.agency = data.value;
                    break;
                case 'tarifas':
                    state.storeHasModified.rates = data.value;
                    break;
                case 'descuentos':
                    state.storeHasModified.discounts = data.value;
                    break;
                case 'modal':
                    state.storeHasModified.modalState = data.value;
                    break;
            }
        },
        storeResetState(state) {
            Object.assign(state, getDefaultState());
        }
    },
    actions: {},
    getters: {
        getHasModified: state => {
            let msg = '';
            if (state.storeHasModified.agency) {
                msg = 'Agencias, ';
            }
            if (state.storeHasModified.rates) {
                msg += 'Tarifas, ';
            }
            if (state.storeHasModified.discounts) {
                msg += 'Descuentos, ';
            }

            if (msg != '') {
                msg = msg.substring(0, msg.length - 2);
            }

            return msg;
        }
    }
}